import { asyncRoutes } from '@/router'

/**
 * 检查路由权限
 * permissions 为 ['*'] 表示超级管理员，拥有全部权限
 */
function hasPermission(permissions, route) {
  if (route.meta && route.meta.permissions) {
    if (permissions.includes('*')) {
      return true
    }
    return route.meta.permissions.some(function(p) {
      return permissions.includes(p)
    })
  }
  return true
}

function filterAsyncRoutes(routes, permissions) {
  var res = []
  routes.forEach(function(route) {
    var tmp = Object.assign({}, route)
    if (hasPermission(permissions, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, permissions)
        if (tmp.children.length === 0) return
      }
      res.push(tmp)
    }
  })
  return res
}

var state = {
  routes: [],
  addRoutes: [],
  routesGenerated: false
}

var mutations = {
  SET_ROUTES: function(state, routes) {
    state.addRoutes = routes
    state.routes = routes
    state.routesGenerated = true
  },
  RESET_ROUTES: function(state) {
    state.routes = []
    state.addRoutes = []
    state.routesGenerated = false
  }
}

var actions = {
  generateRoutes: function({ commit }, permissions) {
    return new Promise(function(resolve) {
      var accessedRoutes
      if (permissions.includes('*')) {
        accessedRoutes = asyncRoutes
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, permissions)
      }
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
}
